import { FC } from 'react'
import { Alert, Flex } from 'antd'
import { RunStatus } from '@signifyd/cypress'
import { toTitleCase } from '@signifyd/utils'
import { Title } from '@signifyd/components'

const getAlertType = (status: RunStatus): 'warning' | 'success' | 'error' => {
  const warningStatuses = ['skipped', 'flaky', 'interrupted']
  const failedStatuses = ['failed', 'timedOut']

  if (warningStatuses.includes(status)) {
    return 'warning'
  }

  if (failedStatuses.includes(status)) {
    return 'error'
  }

  return 'success'
}

const RunDetailsBanner: FC<{ status?: RunStatus }> = ({ status }) => {
  if (!status) {
    return null
  }

  const alertType = getAlertType(status)

  return (
    <Alert
      banner
      type={alertType}
      message={
        <Flex align="center" gap={10} style={{ textAlign: 'center' }}>
          <Title level={3}>{toTitleCase(status)}</Title>
        </Flex>
      }
    />
  )
}

export default RunDetailsBanner
